module.exports = __webpack_public_path__ + "static/media/GTWalsheimPro-Medium.86882f7d.woff";